import HelloSign from 'hellosign-embedded';

const client = new HelloSign();

export default client;
